import reqwest from 'reqwest';
import { apiUrl } from './config';
import session from './session';

export default {
  // 获取权限
  getCrtAuthorityList(data) {
    return reqwest({
      url: `${apiUrl}/business-api/api/project/permission/getCurrentPermissionInfo`,
      method: 'get',
      data,
      headers: {
        sessionId: session.get(),
      },
    });
  },
};
